import {
    Divider,
    IconChevronLeftRegular,
    IconEuroSymbolCircleRegular,
    NavigationBar,
    Row,
    Text2,
    Text6,
    ThemeVariant,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import React from 'react';
import BillingCycle from '../BillingCycle';
import FiberConsumptionData from '../FiberConsumptionData';
import './index.scss';
import { useTranslation } from 'react-i18next';
import '../../translations/i18n';
import { formatMobileNumber, formatPrices } from '../../utils/dataTransformation/unitsConversion';
import { useNavigate, useSearchParams } from 'react-router-dom';
import navigateParams from '../../utils/navigation/navigateParams';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../utils/store/features/user';
import useUserlight from '../../hooks/useUserLight';
import { isWebviewAndroid, isWebviewIOS } from '../../utils/navigation/controlDevices';
import BreadCrumbsWrapper from '../BreadcrumbsWrapper';

export interface FiberConsumptionDataInterface {
    dataTab: any;
    BillingCycleData: string;
    closing: any;
}

export const FiberConsumption: React.FC<FiberConsumptionDataInterface> = ({
    dataTab,
    BillingCycleData,
    closing,
}: FiberConsumptionDataInterface) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isLight = useUserlight();
    const size = useWindowSize();
    const storage = localStorage.getItem('storage');
    let number: any;
    let storageJson: any;
    let extraSum: any;
    if (storage) {
        storageJson = JSON.parse(storage);
        extraSum = formatPrices(storageJson.extraSum, 'spent');
        number = storageJson.number;
    }

    const getRootPath = () => {
        return window.location.pathname.includes('phone') ? 'phone' : 'mobile';
    };

    const sendToNative = () => {
        if (isLight) {
            dispatch(showSnackbar());
        } else {
            const type = 'modeFlow-backgroundBlue';
            const url = `/${getRootPath()}/extra-expense`;
            const title = 'Detalle de gasto extra';
            const productPsId: string = searchParams.get('productPsId')!;
            const queryParams = { productPsId };
            if (navigateParams(type, url, queryParams, storageJson, title)) {
                sessionStorage.setItem(
                    'breadcrumb',
                    JSON.stringify([{ title: t('permanent'), url: `/phone?productPsId=${number}` }]),
                );
                navigate(url + '?productPsId=' + productPsId);
            }
        }
    };

    return (
        <div className='FiberConsumption'>
            <div
                className='FiberConsumption__mobile'
                style={{
                    background: skinVars.colors.background,
                    borderBottom: size.width >= 1024 ? `1px solid ${skinVars.colors.divider}` : '',
                }}
            >
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='FiberConsumption__mobile-navigationBar'>
                            <NavigationBar
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={t('permanent')}
                            />
                        </div>
                        <div className='FiberConsumption__mobile-return'>
                            <div className='FiberConsumption__mobile-return-cursor' onClick={() => navigate(-1)}>
                                <div className='FiberConsumption__mobile-return-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.neutralHigh} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.neutralHigh}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </div>
                    </>
                )}
                <div className='FiberConsumption__mobile-breadcrumbs'>
                    <ThemeVariant>
                        <BreadCrumbsWrapper
                            title={t('permanent')}
                            breadcrumbs={[{ title: t('breadcrumbsHome'), url: '/home' }]}
                        />
                    </ThemeVariant>
                </div>
                <div className='FiberConsumption__mobile-number'>
                    <Text6 color={skinVars.colors.textPrimary}>{number && formatMobileNumber(number)}</Text6>
                </div>
            </div>
            <div className='FiberConsumption__content'>
                {storageJson?.voiceToMobile || storageJson?.voiceToPhone ? (
                    <div className='FiberConsumption__content-data'>
                        <FiberConsumptionData dataTab={dataTab}></FiberConsumptionData>
                    </div>
                ) : (
                    <div></div>
                )}
                <div className='FiberConsumption__content-extraExpense'>
                    <Row
                        title={t('extraExpense')}
                        asset={
                            <IconEuroSymbolCircleRegular
                                color={skinVars.colors.textPrimary}
                            ></IconEuroSymbolCircleRegular>
                        }
                        extra={
                            <Text6
                                color={
                                    storageJson.extraSum > 0 ? skinVars.colors.errorHigh : skinVars.colors.textPrimary
                                }
                            >
                                {extraSum}
                            </Text6>
                        }
                        onPress={() => {
                            sendToNative();
                        }}
                    ></Row>
                    <Divider></Divider>
                </div>
                <div className='FiberConsumption__content-billingCycle'>
                    <BillingCycle BillingCycle={BillingCycleData} closing={closing}></BillingCycle>
                </div>
            </div>
        </div>
    );
};

export default FiberConsumption;
